module.exports = __webpack_public_path__ + "img/fig9.25.d9f25c5d.png";